import {useMemo} from "react";

// Split seconds into whole hours + minutes for the headline
// (plain-language: "1 hour 20 minutes", not "1.3 hours").
export const toHoursMinutes = (seconds) => {
  const totalMinutes = Math.round((Number(seconds) || 0) / 60);
  return {hours: Math.floor(totalMinutes / 60), minutes: totalMinutes % 60};
};

const VideoStats = ({activity, watchHistory}) => {
  const videoSeconds = useMemo(() => {
    // Current calendar month only (e.g. "2026-06"); daily keys are YYYY-MM-DD.
    const now = new Date();
    const monthPrefix = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
    let video = 0;
    Object.entries(activity || {}).forEach(([date, stats]) => {
      if (date.startsWith(monthPrefix)) {
        video += stats.totalVideoSeconds || 0;
      }
    });
    return video;
  }, [activity]);

  const {hours, minutes} = toHoursMinutes(videoSeconds);
  const parts = [];
  if (hours > 0)
    parts.push({value: hours, unit: hours === 1 ? "hour" : "hours"});
  if (minutes > 0 || hours === 0)
    parts.push({value: minutes, unit: minutes === 1 ? "minute" : "minutes"});

  return (
    <section className="mb-4">
      <p className="text-lg sm:text-xl font-semibold text-[#262626] mb-3 max-w-2xl">
        Watch job training videos to meet Idaho&rsquo;s work requirements and
        keep your SNAP or TAFI benefits.
      </p>
      <div className="bg-[#F8FAFC] border border-slate-100 rounded-2xl shadow-sm p-4">
        <p className="text-sm font-semibold text-[#262626] tracking-tight">
          Your progress this month
        </p>
        <p className="mt-1 leading-none">
          {parts.map(({value, unit}, i) => (
            <span key={unit}>
              {i > 0 && " "}
              <span className="text-3xl font-bold text-[#001489]">
                {value}
              </span>{" "}
              <span className="text-lg font-bold text-[#001489]">{unit}</span>
            </span>
          ))}
        </p>
        <p className="text-xs font-medium text-[#262626]/60 mt-1">
          of videos watched this month
        </p>
      </div>
    </section>
  );
};

export default VideoStats;
